/*
 * @Author: bbqin
 * @Date: 2022-11-08 15:33:02
 * @LastEditTime: 2023-07-06 15:51:08
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\setting\libs\request.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import { ajax, pageTo, removeMetaCache, toast } from '@platform/api';

function getConfig(meta = {}) {
    return {
        appCode: meta.appcode || pageTo.getAppCode(),
        pageCode: meta.pagecode || pageTo.getPageCode(),
        code: meta.templateCode || meta.code,
        pageId: meta.pageid || meta.pageid,
        areaId: meta.oid,
    };
}

// 获取用户级模板设置
export function getRawColumns(oldMeta) {
    const config = getConfig(oldMeta);
    return new Promise((resolve, reject) => {
        ajax({
            url: '/nccloud/platform/template/getUserTemplateMap.do',
            async: true,
            data: {
                appcode: config.appCode || pageTo.getAppCode(),
                pagecode: config.pageCode || pageTo.getPageCode(),
                templatecode: config.code,
                templateId: config.pageId,
                areatype: '2',
            },
            success: res => {
                resolve(res);
            },
            error: err => {
                console.error(err);
                toast({
                    content: err.message,
                    color: 'danger',
                });
                reject(err);
            },
        });
    });
}

// 设置用户级模板数据
export function setColumns(oldMeta, data) {
    const config = getConfig(oldMeta);
    return new Promise((resolve, reject) => {
        ajax({
            url: '/nccloud/platform/template/propertySetting.do',
            data: {
                appcode: config.appCode || pageTo.getAppCode(),
                pagecode: config.pageCode || pageTo.getPageCode(),
                templatecode: config.code,
                templateId: config.pageId,
                ...data,
            },
            success: res => {
                removeMetaCache(config.appCode, config.pageCode);
                resolve(res);
            },
            error: err => {
                console.error(err);
                toast({
                    content: err.message,
                    color: 'danger',
                });
                reject(err);
            },
        });
    });
}

export function resetWidths(oldMeta, id) {
    const config = getConfig(oldMeta);
    return new Promise((resolve, reject) => {
        ajax({
            url: '/nccloud/platform/template/resetwidth.do',
            data: {
                templateId: config.pageId,
                areaId: id,
            },
            success: res => {
                removeMetaCache(config.appCode, config.pageCode);
                resolve(res);

            },
            error: err => {
                console.error(err);
                toast({
                    content: err.message,
                    color: 'danger',
                });
                reject(err);
            },
        });
    });
}

// 重置
export function resetColumns(oldMeta) {
    const config = getConfig(oldMeta);
    return new Promise((resolve, reject) => {

        ajax({
            url: '/nccloud/platform/template/removeUserPropertySettings.do',
            data: {
                templateId: config.pageId,
                isall: 'true',
            },
            success: res => {
                removeMetaCache(config.appCode, config.pageCode);
                resolve(res);
            },
            error: err => {
                console.error(err);
                toast({
                    content: err.message,
                    color: 'danger',
                });
                reject(err);
            },
        });
    });
}